import { render, staticRenderFns } from "./GroupRegist.vue?vue&type=template&id=8a6dfa3a"
import script from "./GroupRegist.vue?vue&type=script&lang=js"
export * from "./GroupRegist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports